/**
 * Every registration endpoint, once.
 *
 * One exported function per endpoint, with the CSRF token and the Accept header
 * set in one place. Nothing else in the app posts to these routes directly, so how
 * a request is shaped and what a failure looks like is decided here and nowhere
 * else.
 *
 * Endpoints that belong to buying rather than registering — the Stripe checkout
 * session, the promo code, the challenge word — are not here; they live with
 * doors/plans, which owns that half.
 */

function buildHeaders(extraHeaders = {}) {
    const headers = {
        Accept: 'application/json'
    };

    const token = $('meta[name="csrf-token"]').attr('content');
    if (token) {
        headers['X-CSRF-TOKEN'] = token;
    }

    return Object.assign(headers, extraHeaders);
}

function request(method, url, data, options = {}) {
    return $.ajax({
        url,
        method,
        data,
        headers: buildHeaders(options.headers || {})
    });
}

function post(url, data, options = {}) {
    return request('POST', url, data, options);
}

function get(url, data, options = {}) {
    return request('GET', url, data, options);
}

export function checkEmail(email) {
    return post('/check-email', { email });
}

export function login(payload) {
    return post('/login', payload);
}

export function sendLoginCode(email) {
    return post('/send-login-code', { email });
}

export function verifyLoginCode(payload) {
    return post('/verify-login-code', payload);
}

export function verifyEmail(payload) {
    return post('/email/verify', payload, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
}

export function resendEmail(payload) {
    return post('/email/resend', payload, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
}

export function changeEmail(email) {
    return post('/email/change', { email }, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
}

export function checkEmailVerification(id) {
    return get('/check-email-verification', { id });
}

export function registerWithAction(actionUrl, formData) {
    return post(actionUrl, formData);
}
